<template>
  <div class="d-flex align-center justify-end">
    <v-btn
      v-if="orderId !== -5"
      text
      icon
      min-width="max-content"
      class="pa-0 mx-2"
      :ripple="false"
      @click="$emit('edit-clicked', rowId)"
      :class="{ 'pointer-none': $store.getters.isLoading }"
    >
      <v-icon class="fi fi-ss-pen-circle" color="accent" size="24"></v-icon>
    </v-btn>
    <v-btn
      v-if="
        !disabledDelete &&
          orderId !== -5 &&
          (!$validate.DataValid(orderId) || (orderId < 0 && orderId !== -3) || orderStatus === 'pending')
      "
      text
      icon
      min-width="max-content"
      class="pa-0 mx-2"
      :ripple="false"
      @click="$emit('delete-clicked', rowId)"
      :class="{ 'pointer-none': $store.getters.isLoading }"
    >
      <v-icon class="fi fi-ss-cross-circle" color="red" size="24"></v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'ItemAction',
  props: {
    rowId: {
      type: Number,
      default: -1,
      required: true,
    },
    orderId: {
      type: Number,
      default: -1,
      required: true,
    },
    orderStatus: {
      type: String,
      default: '',
      required: true,
    },
    disabledDelete: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {},
  methods: {},
}
</script>
